<template>
  <div class="row shopStatement">
    <div class="col">
      <div class="Title">店家聲明</div>
      <div class="Statement" v-html="this.$parent.$data.shopStatement"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopStatement",
}
</script>

<style lang="scss" scoped>
.shopStatement {
  margin: 20px auto 20px auto !important;
  > .col {
    > .Title {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 900;
      color: #87CEFAAA;
      text-shadow: 1px 1px 0 #000000;
    }
    > .Statement {
      padding: 15px 20px 15px 20px;
      border-radius: 8px;
      background: #f8f8f8;
      color: #000000;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>